import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface SignUpModalProps {
  open: boolean;
  onClose: () => void;
}

function SignUpModal({ open, onClose }: SignUpModalProps) {
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Handle form submission here
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="div">
          Sign Up for Updates
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} component="form" onSubmit={handleSubmit}>
          <TextField
            label="Name"
            variant="outlined"
            required
            fullWidth
            size="small"
          />
          <TextField
            label="Phone"
            variant="outlined"
            required
            fullWidth
            size="small"
            type="tel"
          />
          <TextField
            label="Email (optional)"
            variant="outlined"
            fullWidth
            size="small"
            type="email"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Maybe Later
        </Button>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleSubmit}
          type="submit"
        >
          Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SignUpModal; 